var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12539 -18532)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(-12539 18532)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12534.459 18538.035)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3413.416-881.644a5.084,5.084,0,0,1,.737.137,1.133,1.133,0,0,1,.755,1.245,1.02,1.02,0,0,1-1.076.847c-.652.013-1.305,0-1.958,0h-4.917c-.77,0-.951-.177-.953-.962,0-2.625,0-5.249,0-7.874a4.473,4.473,0,0,0-.9-2.841,4.382,4.382,0,0,0-4.252-1.745,4.31,4.31,0,0,0-3.722,3.245,4.809,4.809,0,0,0-.185,1.394c-.017,2.583-.008,5.166-.009,7.749,0,.859-.17,1.033-1.01,1.033h-6.707a1.136,1.136,0,0,1-1.206-1.012,1.065,1.065,0,0,1,1.1-1.153c.337-.017.413-.125.412-.442q-.013-9.333.006-18.665c0-.49-.289-.438-.574-.488a1.105,1.105,0,0,1-.8-1.617,1.17,1.17,0,0,1,.976-.545,2.827,2.827,0,0,1,.333,0h24.039a1.253,1.253,0,0,1,1.284.581,1.041,1.041,0,0,1-.774,1.57c-.587.1-.587.1-.587.683q0,9.166,0,18.331Zm-11.947-15.394q-4.645,0-9.292,0c-.312,0-.529.02-.528.433q.015,7.313,0,14.626c0,.32.128.4.423.4.736-.014,1.473-.022,2.208,0,.373.013.473-.117.47-.477-.015-2-.027-4,0-6a7.967,7.967,0,0,1,.248-2.015,6.37,6.37,0,0,1,5.409-4.877,6.428,6.428,0,0,1,5.7,1.75,6.661,6.661,0,0,1,2.07,5.011c.028,2.042.018,4.084,0,6.125,0,.4.129.5.5.483.707-.024,1.417-.027,2.125,0,.373.015.466-.11.466-.473q-.017-7.23,0-14.46c0-.432-.142-.536-.553-.534C3407.636-897.031,3404.552-897.038,3401.469-897.037Zm-.009-4.085c-3.109,0-6.219,0-9.328-.007-.355,0-.518.089-.482.465.025.261,0,.527,0,.791,0,.667,0,.667.654.667h18.322c.1,0,.2-.006.292,0,.245.016.355-.083.344-.34-.014-.333,0-.666,0-1,0-.577,0-.578-.56-.578Z",
    transform: "translate(-3388.005 903.339)",
    fill: "currentColor",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWs);
export default __webpack_public_path__ + "static/media/icon-ws.30d721e6.svg";
export { ForwardRef as ReactComponent };